import React from 'react';
import { Calendar, Share2, ImageIcon, X } from 'lucide-react';
import Card from '../ui/Card';
import { formatHours } from '../../utils/helpers';

const AttendanceRecords = ({ 
  selectedStudent, 
  setSelectedStudent, 
  selectedCourse, 
  setSelectedCourse, 
  attendanceRecords, 
  students, 
  studentCourses, 
  showStudentSelector, 
  setShowStudentSelector, 
  showCourseSelector, 
  setShowCourseSelector, 
  studentSearchTerm, 
  setStudentSearchTerm, 
  courseSearchTerm, 
  setCourseSearchTerm,
  handleLoadMore,
  loadingMore,
  hasMore,
  onTokenAccess
}) => {
  return (
    <Card className="p-3">

      <div className="grid grid-cols-2 gap-3 mb-4">
        <div>
          <div className="relative">
            <input
              type="text"
              value={selectedStudent ? (selectedStudent === 'all' ? '全部学生' : (students.find(s => s.id == selectedStudent)?.name || '')) : ''}
              readOnly
              placeholder="点击选择学生"
              onClick={() => {
                setShowStudentSelector(true);
                setShowCourseSelector(false);
              }}
              className="w-full px-3 py-1.5 border-[#E2E8F0] rounded-lg text-sm bg-white cursor-pointer shadow-sm"
            />
            {selectedStudent && selectedStudent !== 'all' ? (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedStudent('all');
                  setSelectedCourse('all');
                  setShowStudentSelector(false);
                }}
                className="absolute right-2 top-2 text-gray-400 hover:text-gray-600 p-0.5 rounded-full hover:bg-gray-100 transition-colors"
                title="清除学生过滤"
              >
                <X size={14} />
              </button>
            ) : (
              <div className="absolute right-2 top-2.5 pointer-events-none">
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                </svg>
              </div>
            )}
            
            {/* 学生选择弹出层 */}
            {showStudentSelector && (
              <div className="absolute z-10 w-full mt-1 bg-white border border-[#E2E8F0] rounded-lg shadow-lg max-h-60 overflow-y-auto">
                <div className="p-2 border-b border-[#EDF2F7]">
                  <input
                    type="text"
                    placeholder="搜索学生..."
                    value={studentSearchTerm}
                    onChange={(e) => setStudentSearchTerm(e.target.value)}
                    className="w-full p-2 border-[#E2E8F0] rounded text-sm"
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                {/* 全部学生选项 */}
                <div
                  onClick={() => {
                    setSelectedStudent('all');
                    setSelectedCourse('all');
                    setShowStudentSelector(false);
                    setStudentSearchTerm('');
                  }}
                  className="p-2 hover:bg-[#F7FAFC] cursor-pointer border-b border-[#EDF2F7] text-sm"
                >
                  全部学生
                </div>
                {students
                  .filter(student =>
                    student.name.toLowerCase().includes(studentSearchTerm.toLowerCase())
                  )
                  .map(student => (
                    <div
                      key={student.id}
                      onClick={() => {
                        setSelectedStudent(student.id);
                        setSelectedCourse('all'); // 选择具体学生时，默认显示该学生的全部课程
                        setShowStudentSelector(false);
                        setStudentSearchTerm('');
                      }}
                      className="p-2 hover:bg-[#F7FAFC] cursor-pointer border-b border-[#EDF2F7] last:border-b-0 text-sm flex items-center justify-between"
                    >
                      <span className="font-medium text-[#2D3748]">{student.name}</span>
                      {student.last_attendance_date && (
                        <span className="text-[11px] text-[#718096] bg-[#EDF2F7] px-1.5 py-0.5 rounded font-mono">
                          {student.last_attendance_date.substring(5, 10)}
                        </span>
                      )}
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
        
        <div>
          <div className="relative">
            <input
              type="text"
              value={selectedStudent === 'all' ? '全部课程' : (selectedCourse === 'all' || !selectedCourse ? '全部课程' : (studentCourses.find(c => c.id == selectedCourse)?.name || '全部课程'))}
              readOnly
              placeholder="点击选择课程"
              onClick={() => {
                if (selectedStudent && selectedStudent !== 'all') {
                  setShowCourseSelector(true);
                  setShowStudentSelector(false);
                }
              }}
              disabled={selectedStudent === 'all'}
              className={`w-full px-3 py-1.5 border-[#E2E8F0] rounded-lg text-sm bg-white cursor-pointer shadow-sm ${selectedStudent === 'all' ? 'bg-gray-100 cursor-not-allowed' : ''}`}
            />
            <div className="absolute right-2 top-2.5">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
            
            {/* 课程选择弹出层 */}
            {showCourseSelector && selectedStudent && selectedStudent !== 'all' && (
              <div className="absolute z-10 w-full mt-1 bg-white border-[#E2E8F0] rounded-lg shadow-lg max-h-60 overflow-y-auto">
                <div className="p-2 border-b border-[#EDF2F7]">
                  <input
                    type="text"
                    placeholder="搜索课程..."
                    value={courseSearchTerm}
                    onChange={(e) => setCourseSearchTerm(e.target.value)}
                    className="w-full p-2 border-[#E2E8F0] rounded text-sm"
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                {/* 全部课程选项 */}
                <div
                  onClick={() => {
                    setSelectedCourse('all');
                    setShowCourseSelector(false);
                    setCourseSearchTerm('');
                  }}
                  className="p-2 hover:bg-[#F7FAFC] cursor-pointer border-b border-[#EDF2F7] text-sm"
                >
                  全部课程
                </div>
                {studentCourses
                  .filter(course =>
                    course.name.toLowerCase().includes(courseSearchTerm.toLowerCase())
                  )
                  .map(course => (
                    <div
                      key={course.id}
                      onClick={() => {
                        setSelectedCourse(course.id);
                        setShowCourseSelector(false);
                        setCourseSearchTerm('');
                      }}
                      className="p-2 hover:bg-[#F7FAFC] cursor-pointer border-b border-[#EDF2F7] last:border-b-0 text-sm"
                    >
                      {course.name}
                    </div>
                  ))}
              </div>
            )}
          </div>
        </div>
      </div>
      
      {/* 点击页面其他地方关闭弹出层 */}
      {(showStudentSelector || showCourseSelector) && (
        <div
          className="fixed inset-0 z-0"
          onClick={() => {
            setShowStudentSelector(false);
            setShowCourseSelector(false);
            setStudentSearchTerm('');
            setCourseSearchTerm('');
          }}
        ></div>
      )}
      
      <div className="space-y-1">
        <div className="grid grid-cols-6 gap-2 text-xs font-bold text-[#718096] px-2 py-2 bg-[#F7FAFC] rounded-t" style={{ gridTemplateColumns: '2fr 0.8fr 2fr 2fr 1.2fr 0.8fr' }}>
          <div className="flex items-center justify-center">日期</div>
          <div className="flex items-center justify-center">周</div>
          <div className="flex items-center justify-center">学生</div>
          <div className="flex items-center justify-center">课程</div>
          <div className="flex items-center justify-center">消/剩</div>
          <div className="flex items-center justify-center text-gray-300"><Share2 size={10} /></div>
        </div>
        
        {attendanceRecords.map((record, index) => {
            const isVoided = record.status === 'VOIDED';
            
            // 格式化日期为 yy/MM/dd
            const recordDate = new Date(record.date);
            const formattedDate = `${recordDate.getFullYear().toString().substr(-2)}/${String(recordDate.getMonth() + 1).padStart(2, '0')}/${String(recordDate.getDate()).padStart(2, '0')}`;
            
            // 获取星期几
            const weekdays = ['日', '一', '二', '三', '四', '五', '六'];
            const weekday = weekdays[recordDate.getDay()];
            
            // 截取课程名称前4个字符
            const courseName = record.course_name && record.course_name.length > 4
                              ? record.course_name.substring(0, 4)
                              : (record.course_name || (record.course && record.course.length > 4
                                ? record.course.substring(0, 4)
                                : record.course) || '');
            
            const isCurrentStudentFiltered = selectedStudent == record.student_id;

            return (
              <div
                key={record.id}
                className={`grid grid-cols-6 gap-2 text-[13px] py-2 px-2 rounded transition-colors ${
                  isVoided 
                    ? 'bg-gray-100/50 opacity-60' 
                    : (index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50')
                }`}
                style={{ gridTemplateColumns: '2fr 0.8fr 2fr 2fr 1.2fr 0.8fr' }}
              >
                <div className="flex items-center justify-center text-[#4A5568]">{formattedDate}</div>
                <div className="flex items-center justify-center text-[#718096] font-medium">{weekday}</div>
                <div className="flex items-center justify-center truncate">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (setSelectedStudent) {
                        if (isCurrentStudentFiltered) {
                          setSelectedStudent('all');
                        } else {
                          setSelectedStudent(record.student_id);
                        }
                      }
                      if (setSelectedCourse) {
                        setSelectedCourse('all');
                      }
                      if (setShowStudentSelector) setShowStudentSelector(false);
                      if (setShowCourseSelector) setShowCourseSelector(false);
                    }}
                    className={`font-medium truncate max-w-full px-1.5 py-0.5 rounded transition-all cursor-pointer ${
                      isCurrentStudentFiltered
                        ? 'text-blue-700 bg-blue-100/80 font-bold'
                        : 'text-[#3182CE] hover:text-[#2B6CB0] hover:underline active:opacity-75'
                    }`}
                    title={isCurrentStudentFiltered ? '已过滤该学生，点击取消过滤' : `点击过滤学生：${record.student_name}`}
                  >
                    {record.student_name}
                  </button>
                </div>
                <div className="flex items-center justify-center text-[#4A5568] truncate">{courseName}</div>
                <div className="flex items-center justify-center text-[#3182CE] font-bold">{formatHours(record.consumed_hours || 0)}/{formatHours(record.remaining_hours || 0)}</div>
                <div className="flex items-center justify-center">
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onTokenAccess && onTokenAccess({ id: record.student_id, name: record.student_name });
                    }}
                    className="p-1 text-gray-400 hover:text-[#3182CE] hover:bg-white rounded transition-all"
                  >
                    <Share2 size={14} />
                  </button>
                </div>
              </div>
            );
          })}
      </div>

      {/* 加载更多 */}
      {attendanceRecords.length > 0 && (
        <div className="mt-4 text-center">
          {hasMore ? (
            <button
              onClick={handleLoadMore}
              disabled={loadingMore}
              className={`text-sm font-bold py-2 px-4 rounded-lg transition-all ${
                loadingMore 
                ? 'text-gray-400 bg-gray-50' 
                : 'text-blue-600 hover:bg-blue-50 bg-white border border-blue-100'
              }`}
            >
              {loadingMore ? (
                <span className="flex items-center gap-2">
                  <svg className="animate-spin h-3 w-3 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  加载中...
                </span>
              ) : '加载更多'}
            </button>
          ) : (
            <p className="text-xs text-gray-400">没有更多记录了</p>
          )}
        </div>
      )}
    </Card>
  );
};

export default AttendanceRecords;